import { ChainId } from '../../sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.AIEAGLE]: '0xE37f96111e5c5BA05Fb66C489D4202a5ad8a61b0'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
